import getAxiosInstance from '../../helpers/get_axios_instance'
import lrsAdapter from '../../helpers/lrs_adapter'

class LeerPesoBruto {
  static adaptToBackend (cpe = {}, pesadoBruto, error) {
    const {
      numero,
      pesoBruto,
      chofer
    } = cpe

    return {
      numero: numero,
      pesoBrutoOrigen: pesoBruto,
      pesoBruto: pesadoBruto,
      chofer: chofer,
      error: error ? true : null,
      errorDescripcion: error
    }
  }

  static getCpePesadoBruto () {
    const axios = getAxiosInstance()
    const promise = axios.get(`cpe_en_bruto?r=` +
    '{}')
    return promise.then((result) => {
      const { data } = result
      if (data.estado === 'exito') {
        if (data.filas_procesadas > 0) {
          return data.filas[0]
        }
      }
    })
  }

  static monitor () {
    const axios = getAxiosInstance()
    const promise = axios.get(`monitor_peso_bruto?r=` +
    '{}')
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data[0] })
  }

  static altaCpeEnBruto (cpe, pesadoBruto, error) {
    const axios = getAxiosInstance()
    const valores = this.adaptToBackend(cpe, pesadoBruto, error)
    const promise = axios.post(`cpe_en_bruto`, { valores: { ...valores } })
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then((result) => result.data[0])
  }

  static deleteCpeEnBruto (numero) {
    const axios = getAxiosInstance()
    const promise = axios.delete(`cpe_en_bruto?r=` +
    `{"clave": {"numero": "${numero}"}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .catch(lrsAdapter)
      .then((result) => { return result.data[0] })
  }

  static updateCpeEnBruto (numero, calle) {
    const axios = getAxiosInstance()
    const promise = axios.put(`cpe_en_bruto`, `{"valores": {"calle_de_volcadora": "${calle}"}, "clave": {"numero": "${numero}"}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .catch(lrsAdapter)
      .then((result) => { return result.data[0] })
  }

  static updatePesoCpeEnBruto (numero, pesoBruto) {
    const axios = getAxiosInstance()
    const promise = axios.put(`cpe_en_bruto`, `{"valores": {"peso_bruto": "${pesoBruto}"}, "clave": {"numero": "${numero}"}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .catch(lrsAdapter)
      .then((result) => { return result.data[0] })
  }

  static updateConfirmacionChoferCpeEnBruto (numero, confirmacion, descripcion) {
    const axios = getAxiosInstance()
    const promise = axios.put(`cpe_en_bruto`, `{"valores": {"confirmacion_de_chofer": "${confirmacion}", "error_descripcion": "${descripcion}"}, "clave": {"numero": "${numero}"}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .catch(lrsAdapter)
      .then((result) => { return result.data[0] })
  }

  static updateCalleVolcadoraCpeEnBruto (numero, calleDeVolcadora) {
    const axios = getAxiosInstance()
    const promise = axios.put(`cpe_en_bruto`, `{"valores": {"calle_de_volcadora": "${calleDeVolcadora}"}, "clave": {"numero": "${numero}"}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .catch(lrsAdapter)
      .then((result) => { return result.data[0] })
  }

  static updateRechazoEnCpeBruto (numero, error, descripcion) {
    const axios = getAxiosInstance()
    const promise = axios.put(`cpe_en_bruto`, `{"valores": {"error": "${error}", "error_descripcion": "${descripcion}"}, "clave": {"numero": "${numero}"}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .catch(lrsAdapter)
      .then((result) => { return result.data[0] })
  }

  static leerPesoBruto () {
    const axios = getAxiosInstance()
    const promise = axios.get(`leer_peso_bruto?r=` +
      '{}')
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data[0] })
  }
}

export default LeerPesoBruto
